import { render } from "./printOrderRecord.vue?vue&type=template&id=5953840e&scoped=true"
import script from "./printOrderRecord.vue?vue&type=script&lang=js"
export * from "./printOrderRecord.vue?vue&type=script&lang=js"

import "./printOrderRecord.vue?vue&type=style&index=0&id=5953840e&lang=css"
import "./printOrderRecord.vue?vue&type=style&index=1&id=5953840e&scoped=true&lang=css"

import exportComponent from "D:\\AAA_WORK\\os_FMS_sys_projectop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5953840e"]])

export default __exports__